/* istanbul ignore file */
import { createAction } from '@reduxjs/toolkit';
import type { IContactFormSubmissionData } from '../../api/domain';

enum ContactFormActions {
    SUBMIT = 'contact-form.submit',
    SUBMIT_FAILURE = 'contact-form.submit-failure',
    PASS_SERVER_ERRORS = 'contact-form.handle-errors',
    SUBMIT_TIMEOUT = 'contact-form.submit-timeout',
}

export const submitContactForm = createAction<IContactFormSubmissionData>(ContactFormActions.SUBMIT);
export const submitContactFormFailure = createAction(ContactFormActions.SUBMIT_FAILURE);
export const submitContactFormTimeout = createAction(ContactFormActions.SUBMIT_TIMEOUT);
